import { data } from '../../svg/Opportunity/data';
import { makeIcon } from '../makeIcon';

export const Opportunity = makeIcon(data, 'opportunity', 'Opportunity');

export default Opportunity;
